import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { FreezeDriedRecipeDetail } from 'features/Recipes/FreezeDriedRecipeDetail'
import { FreezeDriedProteins } from 'models/Pet'

export default function RecipePage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'Chicken Recipe',
    image: [
      'https://wefeedraw.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ffreeze-dried-half-bowl-chicken-v2.0eb63a9f.webp&w=3840&q=75',
      'https://wefeedraw.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ffreeze-dried-ingredient-preparation.80fa9b07.webp&w=1080&q=75',
    ],
    description:
      'Packed with lean protein for muscle health and essential nutrients for digestion and energy.',
    brand: {
      '@type': 'Brand',
      name: 'We Feed Raw',
    },
    manufacturer: {
      '@type': 'Organization',
      name: 'We Feed Raw',
    },
    url: 'https://wefeedraw.com/recipes/freeze-dried-raw-chicken',
    additionalProperty: [
      {
        '@type': 'PropertyValue',
        name: 'Protein',
        value: 'Chicken',
      },
      {
        '@type': 'PropertyValue',
        name: 'Chicken Quality',
        value: 'Cagen Free',
      },
      {
        '@type': 'PropertyValue',
        name: 'Antibiotics',
        value: 'Minimally Processed',
      },
      {
        '@type': 'PropertyValue',
        name: 'Harvesting Method',
        value: 'Humanely Harvested',
      },
    ],
    offers: {
      '@type': 'Offer',
      price: '13.21',
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition',
      seller: {
        '@type': 'Organization',
        name: 'We Feed Raw',
      },
      url: 'https://wefeedraw.com/recipes/freeze-dried-raw-chicken',
      shippingDetails: {
        '@type': 'OfferShippingDetails',
        shippingRate: {
          '@type': 'MonetaryAmount',
          value: '0.00',
          currency: 'USD',
        },
        shippingDestination: {
          '@type': 'DefinedRegion',
          addressCountry: 'US',
        },
      },
      priceSpecification: [
        {
          '@type': 'UnitPriceSpecification',
          price: '22.02',
          priceCurrency: 'USD',
          priceType: 'ListPrice',
        },
        {
          '@type': 'UnitPriceSpecification',
          price: '13.21',
          priceCurrency: 'USD',
          priceType: 'SalePrice',
        },
      ],
    },
    isRelatedTo: {
      '@type': 'Product',
      name: 'Chicken Recipe',
      url: 'https://wefeedraw.com/recipes/chicken',
    },
    isSimilarTo: [
      {
        '@type': 'Product',
        name: 'Beef Recipe',
        url: 'https://wefeedraw.com/recipes/beef',
      },
      {
        '@type': 'Product',
        name: 'Turkey Recipe',
        url: 'https://wefeedraw.com/recipes/turkey',
      },
      {
        '@type': 'Product',
        name: 'Duck Recipe',
        url: 'https://wefeedraw.com/recipes/duck',
      },
      {
        '@type': 'Product',
        name: 'Lamb Recipe',
        url: 'https://wefeedraw.com/recipes/lamb',
      },
      {
        '@type': 'Product',
        name: 'Beef Recipe',
        url: 'https://wefeedraw.com/recipes/freeze-dried-raw-beef',
      },
    ],
  }

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('recipes:freeze-dried.CHICKEN.meta.title')}</title>
        <meta name="title" content={t('recipes:freeze-dried.CHICKEN.meta.title')} />
        <meta name="description" content={t('recipes:freeze-dried.CHICKEN.meta.description')} />
        <link rel="canonical" href="https://wefeedraw.com/recipes/freeze-dried-raw-chicken" />
        <script
          id="schema-script"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLdString }}
        />
      </Head>
      <main>
        <FreezeDriedRecipeDetail protein={FreezeDriedProteins.CHICKEN} />
      </main>
    </div>
  )
}
